module.exports = __webpack_public_path__ + "static/media/353856313_273311251873725_8852931714093670202_n-removebg-preview.f82ea3af.png";